/*
 * Copyright © 2018 Aram Meem Company Limited.  All Rights Reserved.
 */


import * as React from 'react';
import { DeliveryAddress } from '../models/delivery-address';

interface Params {
  deliveryAddress: DeliveryAddress
}


export class FormattedAddress extends React.Component<Params, any> {

  render() {
    if (this.props.deliveryAddress.formattedAddress) {
      return (<p className="order_group-input">
        {this.improveString([
          this.props.deliveryAddress.addressLine2,
          this.props.deliveryAddress.formattedAddress
        ])}
      </p>);
    }

    return (<p className="order_group-input">
      {this.improveString([
        this.props.deliveryAddress.addressLine1,
        this.props.deliveryAddress.addressLine2
      ])}<br/>
      {this.improveString([
        this.props.deliveryAddress.city,
        this.props.deliveryAddress.zip
      ])}<br/>
      {this.improveString([this.props.deliveryAddress.country])}
    </p>)
  }

  private improveString(elements: string[]) {
    return elements.join(' ').trim();
  }
}






// WEBPACK FOOTER //
// ./src/app/components/FormattedAddress.tsx